var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcDownloadErr = function SvgIcDownloadErr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2005_4153)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0004 29.1004C22.7876 29.1004 29.1004 22.7876 29.1004 15.0004C29.1004 7.21318 22.7876 0.900391 15.0004 0.900391C7.21318 0.900391 0.900391 7.21318 0.900391 15.0004C0.900391 22.7876 7.21318 29.1004 15.0004 29.1004Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 0C6.75 0 0 6.75 0 15C0 23.25 6.75 30 15 30C23.25 30 30 23.25 30 15C30 6.75 23.25 0 15 0ZM15 23.0355C14.6818 23.0358 14.3707 22.9417 14.1061 22.7651C13.8414 22.5886 13.6351 22.3374 13.5132 22.0435C13.3913 21.7497 13.3593 21.4262 13.4213 21.1142C13.4833 20.8021 13.6365 20.5154 13.8615 20.2905C14.0864 20.0655 14.3731 19.9123 14.6852 19.8503C14.9972 19.7883 15.3207 19.8203 15.6146 19.9422C15.9084 20.0641 16.1595 20.2704 16.3361 20.5351C16.5127 20.7997 16.6068 21.1108 16.6065 21.429C16.5955 21.8516 16.4227 22.2539 16.1238 22.5528C15.8249 22.8517 15.4226 23.0245 15 23.0355ZM16.392 16.8285C16.392 17.901 15.963 18.7575 15 18.7575C14.037 18.7575 13.6065 17.901 13.6065 16.8285L13.071 8.901C13.071 7.8285 13.9275 6.972 14.892 6.972C15.8565 6.972 16.821 7.8285 16.821 8.901L16.392 16.8285Z",
    fill: "#F86161"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2005_4153"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
};
export default SvgIcDownloadErr;